import React, { InputHTMLAttributes } from 'react';
import DynamicFaIcon from '../DynamicFaIcon';

interface InputTextIconProps extends InputHTMLAttributes<HTMLInputElement> {
    icon: string,
    onClick?: () => void
}

const InputTextIcon = (props: InputTextIconProps) => {
    const { icon, onClick, ...nativeProps } = props;
    return (
        <>
            <div className="input-icon bg-white">
                <input type="text" className="input-block" {...nativeProps} />
                <i className='bg-white text-gray-500 cursor-pointer' onClick={onClick} >
                    <DynamicFaIcon name={icon} />
                </i>
            </div>
        </>
    );
};

export default InputTextIcon;